import { defineComponent as _defineComponent } from 'vue'
import type { ClientStatusValue, TagType } from '@/lib/types/clientStatus';
import { ClientStatusUtils } from '@/lib/types/clientStatus';

/**
 * Get Element UI tag type based on client status
 * Uses centralized ClientStatusUtils for consistent styling
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'ElTableColumnClientStatus',
  setup(__props) {

const getStatusType = (status: ClientStatusValue): TagType => {
	return ClientStatusUtils.getTagType(status);
};

return { __sfc: true,getStatusType }
}

})